// MA-852 (D-PUX-1): the kids list is its own parent tab now. This old
// Settings sub-route redirects to /parent/kids, carrying the search string
// (e.g. ?dev=1) so a deep link lands on the same page.
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/parent/settings/kids")({
  beforeLoad: ({ location }) => {
    throw redirect({ to: "/parent/kids", search: location.search as never, replace: true });
  },
  component: () => null,
});
